import { FormulaLiteModel } from './formula.model';

export enum TriggerOperator {
    Equals = 'equals',
    NotEquals = 'not_equals',
    GreaterThan = 'greater_than',
    LessThan = 'less_than',
    GreaterThanOrEquals = 'greater_than_equals',
    LessThanOrEquals = 'less_than_equals',
}

export const DEFAULT_LOOKBACKS: number[] = [1, 7, 30];

export const SUB_TRIGGER_ID_SLUG = 'NEW_SUB_TRIGGER';
export const TRIGGER_ID_SLUG = 'NEW_TRIGGER';

export const DEFAULT_VALUES = { value: 0, lookback: DEFAULT_LOOKBACKS[0] };

export interface CompoundTriggerModel {
    id: string;
    name: string;
    description?: string;
    exit_event_id?: number;
    created_at: string;
    archived_at?: string;
    trigger_type: CompoundTriggerType;
    delay_period?: CompoundTriggerDelayPeriod;
    delay_minutes?: number;
}

export interface CompoundTriggerCatalog extends CompoundTriggerModel {
    message_count: number;
}

export interface SubTriggerModel {
    id: string;
    contact_event_id: number;
    operator: TriggerOperator;
    value: number;
    lookback: number;
}

export interface TriggerModel {
    id: string;
    contact_event_id: number;
    is_exit_event?: boolean;
}

export interface CompoundTriggerDetailModel extends CompoundTriggerModel {
    sub_triggers: SubTriggerModel[];
    triggers: TriggerModel[];
    formulas: FormulaLiteModel[];
    message_count: number;
}

export interface SubTriggerCreateUpdateModel {
    id?: string;
    contact_event_id?: number;
    operator?: TriggerOperator;
    value?: number;
    lookback?: number;
}

export interface TriggerCreateUpdateModel {
    id?: string;
    contact_event_id?: number;
    is_exit_event?: boolean;
}

export interface CompoundTriggerUpdate {
    name?: string;
    description?: string;
    exit_event_id?: number;
    sub_triggers?: SubTriggerCreateUpdateModel[];
    triggers?: TriggerCreateUpdateModel[];
    trigger_type?: CompoundTriggerType;
    delay_period?: CompoundTriggerDelayPeriod;
    delay_minutes?: number;
}

export interface CompoundTriggerCreate {
    name: string;
    description?: string;
    exit_event_id?: number;
    sub_triggers: SubTriggerCreateUpdateModel[];
    triggers: TriggerCreateUpdateModel[];
    trigger_type: CompoundTriggerType;
    delay_period?: CompoundTriggerDelayPeriod;
    delay_minutes?: number;
}

export enum CompoundTriggerType {
    AAMPE_OPTIMISED = 'aampe_optimised',
    SEND_IMMEDIATELY = 'send_immediately',
    SEND_WITH_DELAY = 'send_with_delay',
}

export const TriggerDisplayNames: Record<CompoundTriggerType, string> = {
    [CompoundTriggerType.AAMPE_OPTIMISED]: 'Aampe optimised',
    [CompoundTriggerType.SEND_IMMEDIATELY]: 'Send immediately',
    [CompoundTriggerType.SEND_WITH_DELAY]: 'Send with delay',
};

export enum CompoundTriggerDelayPeriod {
    DAYS = 'days',
    HOURS = 'hours',
    MINS = 'mins',
    NoneValue = 'None',
}

export const EXIT_SUB_TRIGGER_DESCRIPTION =
    'Stop sending trigger messages for a user if:';
export const SUB_TRIGGER_DESCRIPTION =
    'Start triggering messages for a user if:';
export const RT_TRIGGER_DELAY_PERIOD_DESCRIPTION =
    'Once the trigger event is met, send the messages after';
export const RT_TRIGGER_EXIT_DESCRIPTION =
    'Unless the following exception event occurs:';
